export const requestCommentsQueryKey = 'requestComments'
